<template>
  <div
    v-click-outside="handleClickOutside"
    class="template-slot-row border-sm rounded-lg"
    :class="{ 'border-primary': isEditing, 'cursor-pointer': !isEditing }"
  >
    <div
      v-if="!isEditing"
      class="d-flex align-center ga-2 px-3 py-2"
      @click="startEdit"
    >
      <div class="flex-grow-1">
        <p class="text-body-2 text-textDarkest">
          {{ item.name }}
        </p>
        <p class="mt-1 text-body-2 text-textLight">
          {{ item.description }}
        </p>
      </div>

      <HideRbac :permissions="['updateApprovalTemplate']">
        <v-btn
          variant="outlined"
          rounded="lg"
          height="32"
          width="32"
          icon
          color="strokeDefault"
          @click.stop="$emit('remove')"
        >
          <v-icon
            icon="$delete-outline"
            size="20"
            color="textDark"
          />
        </v-btn>
      </HideRbac>
    </div>

    <v-sheet
      v-else
      rounded="lg"
      class="bg-bgCanvas pa-3 d-flex flex-column ga-1"
    >
      <DpplTextField
        v-model="editName"
        label="Slot Label"
        autofocus
        @keyup.enter="confirmEdit"
      />
      <DpplTextArea
        v-model="editDescription"
        label="Role Hint"
        rows="1"
        @keyup.enter="confirmEdit"
      />
    </v-sheet>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { useAppAuthData } from '@/stores/app/authData';
import HideRbac from '@/components/rbac/HideRbac.vue';
import DpplTextField from '@/components/datapeople/DpplTextField.vue';
import DpplTextArea from '@/components/datapeople/DpplTextArea.vue';

defineOptions({ name: 'TemplateSlotRow' });

const props = defineProps({
  item: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(['update', 'remove']);

const isEditing = ref(false);
const editName = ref('');
const editDescription = ref('');

const { checkRbacPermissions } = useAppAuthData();

const startEdit = () => {
  if (!checkRbacPermissions(['updateApprovalTemplate'])) return;
  if (isEditing.value) return;
  editName.value = props.item.name;
  editDescription.value = props.item.description ?? '';
  isEditing.value = true;
};

const confirmEdit = () => {
  emit('update', { name: editName.value || 'Untitled', description: editDescription.value });
  isEditing.value = false;
};

const handleClickOutside = () => {
  if (isEditing.value) confirmEdit();
};
</script>

<style lang="less" scoped>
.template-slot-row {
  &.border-primary {
    border-color: @indigo-500 !important;
  }
}
</style>
